//* Returns waypoints between sets of x/y coordinates for animation
export const calcWaypoints = (vertices) => {
  const waypoints = [];
  for (let i = 1; i < vertices.length; i++) {
    const pt0 = vertices[i - 1];
    const pt1 = vertices[i];
    const dx = pt1.x - pt0.x;
    const dy = pt1.y - pt0.y;
    for (let j = 0; j < 100; j++) {
      const x = pt0.x + (dx * j) / 100;
      const y = pt0.y + (dy * j) / 100;
      waypoints.push({
        x,
        y,
      });
    }
  }
  return waypoints;
};

//* Used to draw line between two points
// @ context: Required! Canvas context
// @ lineWidth: Number. Width of line to draw
// @ startX: Number. Required! x start position. Can be any X coordinate.
// @ startY: Number. Required! y start position. Can be any Y coordinate.
// @ endX: Number. Required! x end position. Can be any X coordinate.
// @ endY: Number. Required! y end position. Can be any Y coordinate.
// @ label: String. Label to display on line.
// @ dashed: Boolean. True draws dashed line between points. Default false
// @ EX: drawCanvasLine(context, 3, pointX, pointY, pinX, pinY, `${pinDistance} yds`, true);
export const drawCanvasLine = (payload) => {
  const {
    canvas,
    // ctx,
    lineWidth = 2,
    startX = 0,
    startY = 0,
    endX = 0,
    endY = 0,
    label = null,
    dashed = false,
  } = payload;
  let { ctx } = payload;

  if (!ctx) {
    return;
  }

  if (!ctx && canvas) {
    ctx = canvas?.getContext('2d');
  }

  //* set line stroke and line width
  ctx.strokeStyle = 'white';
  ctx.lineWidth = lineWidth;
  ctx.lineCap = 'round';

  ctx.beginPath();
  if (dashed) {
    ctx.setLineDash([5, 5]);
  } else {
    ctx.setLineDash([]);
  }
  ctx.moveTo(startX, startY);
  ctx.lineTo(endX, endY);
  ctx.stroke();

  if (label) {
    setTimeout(() => {
      const textX = Math.round((startX + endX) / 2) + 35;
      const textY = Math.round((startY + endY) / 2);

      ctx.font = `Bold 12px Arial`;
      ctx.fillStyle = 'white';
      ctx.textAlign = 'center';
      ctx.fillText(label, textX, textY);
    }, 250);
  }
};

//* Used to draw curved line between two points
// @ canvas: Required! Canvas object
// @ ctx: Required! Canvas context
// @ canvasWidth: Required! Canvas element width used for calculation
// @ canvasHeight: Required! Canvas element height used for calculation
// @ lineWidth: Number. Width of line to draw
// @ lineColor: String. Color of line to draw on ellipse
// @ fillColor: String. rgba value to fill inner color on ellipse
// @ dashed: Boolean. True draws dashed line between points. Default false
// @ points: Array. Array of object data points to draw ellipse from
// @ EX: drawCanvasEllipse(canvas, ctx, 306, 612, 1, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.2), [{x: 1, y: 2}, {x: 2, y: 3}]);
export const drawCanvasEllipse = (payload) => {
  const {
    canvas,
    canvasWidth = 306,
    canvasHeight = 612,
    lineWidth = 2,
    lineColor = 'rgba(255, 255, 255, 1)',
    fillColor = 'rgba(255, 255, 255, 0.2',
    dashed = false,
    points = [],
  } = payload;
  let { ctx } = payload;

  if (!ctx) {
    return;
  }

  if (!ctx && canvas) {
    ctx = canvas?.getContext('2d');
  }

  //* set line stroke and line width
  ctx.strokeStyle = lineColor;
  ctx.lineWidth = lineWidth;
  ctx.lineCap = 'round';

  ctx.beginPath();
  if (dashed) {
    ctx.setLineDash([5, 5]);
  } else {
    ctx.setLineDash([]);
  }

  //* working circle====================
  // Calculate the center and radius of the circle
  // const centerX = (points[0].x + points[2].x) / 2;
  // const centerY = (points[0].y + points[2].y) / 2;
  // const radius = Math.sqrt((points[0].x - centerX) ** 2 + (points[0].y - centerY) ** 2);

  // // Draw the circle
  // ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
  // *====================

  //* rotated ellipse ================= working!!
  // Calculate the positions based on canvas size
  const point0XCalc = points?.[0]?.x * canvasWidth;
  const point0YCalc = points?.[0]?.y * canvasHeight;
  const point1XCalc = points?.[1]?.x * canvasWidth;
  const point1YCalc = points?.[1]?.y * canvasHeight;
  const point2XCalc = points?.[2]?.x * canvasWidth;
  const point2YCalc = points?.[2]?.y * canvasHeight;
  const point3XCalc = points?.[3]?.x * canvasWidth;
  const point3YCalc = points?.[3]?.y * canvasHeight;

  // Calculate the center of the ellipse
  const centerX = (point0XCalc + point2XCalc) / 2;
  const centerY = (point0YCalc + point2YCalc) / 2;

  // Calculate the semi-major and semi-minor axes
  const semiMajorAxis =
    Math.sqrt((point0XCalc - point2XCalc) ** 2 + (point0YCalc - point2YCalc) ** 2) / 2;
  const semiMinorAxis =
    Math.sqrt((point1XCalc - point3XCalc) ** 2 + (point1YCalc - point3YCalc) ** 2) / 2;

  // Calculate the rotation angle
  const angle = Math.atan2(point2YCalc - point0YCalc, point2XCalc - point0XCalc);
  // const angle = Math.atan2(points[2].y - points[0].y, points[2].x - points[0].x);

  // Draw rotated ellipse connecting all four points
  ctx.beginPath();

  // Apply rotation transformation
  ctx.setTransform(
    Math.cos(angle),
    Math.sin(angle),
    -Math.sin(angle),
    Math.cos(angle),
    centerX,
    centerY
  );

  // Draw the ellipse
  ctx.ellipse(0, 0, semiMajorAxis, semiMinorAxis, 0, 0, 2 * Math.PI);

  // Reset the transformation
  ctx.setTransform(1, 0, 0, 1, 0, 0);

  // Fill ellipse with opaque color
  ctx.fillStyle = fillColor;
  ctx.fill();

  // Stroke the path
  ctx.stroke();
  //* rotated ellipse end ============================
};

//* Used for animating shot line
export const drawCanvasLineAnimated = (
  canvas,
  context,
  lineWidth = 2,
  startX,
  startY,
  endX,
  endY,
  label,
  dashed = false,
  teeShot,
  teeColor
) => {
  const lineColor = teeColor;
  const ctx = canvas.getContext('2d');

  //* set line stroke and line width
  ctx.strokeStyle = 'white';
  ctx.lineWidth = lineWidth;
  ctx.lineCap = 'round';

  let t = 1;
  const vertices = [
    { x: startX, y: startY },
    { x: endX, y: endY },
  ];
  const waypoints = calcWaypoints(vertices);

  if (!teeShot) {
    context.beginPath();
    if (dashed) {
      context.setLineDash([5, 5]);
    } else {
      context.setLineDash([0, 0]);
    }
    context.moveTo(startX, startY);
    context.lineTo(endX, endY);
    context.stroke();
  }

  function animate() {
    ctx.lineWidth = 3;
    ctx.strokeStyle = lineColor ?? 'white';
    ctx.lineCap = 'round';
    if (t < waypoints.length - 1) {
      requestAnimationFrame(animate);
    }
    // draw a line segment from the last waypoint to the current waypoint
    ctx.beginPath();
    ctx.moveTo(waypoints[t - 1].x, waypoints[t - 1].y);
    ctx.lineTo(waypoints[t].x, waypoints[t].y);
    ctx.stroke();
    // increment "t" to get the next waypoint
    t++;
  }

  animate(waypoints);
};

// @ canvas: Required! Canvas element
// @ context: Required! Canvas context
// @ x: Number. Required! x position. Can be ball X or tee X
// @ y: Number. Required! y position. Can be ball Y or tee Y
// @ label: String. Label to display on point.
// @ color: String. Color of point. Default white
// @ size: Number. Size of point. Default 5
// @ offsetX: Number. X offset to shift label. Default 0
// @ offsetY: Number. Y offset to shift label. Default 0
// @ labelSize: String. Size of label. Default 14
// @ drawLine: Boolean to determine if line should be drawn between points
// @ pinDistance: String. Distance to pin for label.
// @ pinX: Number. Pin X coordinate. Used in conjunction with drawLine. Default 0
// @ pinY: Number. Pin Y coordinate. Used in conjunction with drawLine. Default 0
// @ isPoint: Boolean. Determines if point is round or square. Default true
// @ drawTeeToBall: Boolean. Determines if line is drawn from tee location to ball
// @ teeX: Number. Tee x coordinates used in conjuction with drawTeeToBall
// @ teeY: Number. Tee y coordinates used in conjuction with drawTeeToBall
// @ teeShot: Boolean. Determines if shot is from the tee
export const drawPoint = (payload) => {
  const {
    canvas,
    // context,
    x = 0,
    y = 0,
    label = '',
    offsetX = 0,
    offsetY = 0,
    labelSize = '14',
    drawLine = false,
    pinDistance = '',
    pinX = 0,
    pinY = 0,
    isPoint = true,
    drawTeeToBall = false,
    teeX = 0,
    teeY = 0,
    teeShot = false,
  } = payload;
  let { context, color = 'white', size } = payload;

  if (!context) {
    return;
  }

  if (!context && canvas) {
    context = canvas?.getContext('2d');
  }
  if (color === null || !color || color === '#') {
    color = '#FFF';
  }
  if (size === null || !size) {
    size = 5;
  }

  // * to increase smoothing for numbers with decimal part
  const pointX = Math.round(x);
  const pointY = Math.round(y);

  context.beginPath();
  context.fillStyle = color;
  context.globalCompositeOperation = 'destination-over';

  if (isPoint) {
    context.arc(pointX, pointY, size, 0 * Math.PI, 2 * Math.PI);
  } else {
    context.fillRect(pointX, pointY, size, size);
  }

  context.fill();

  if (label) {
    setTimeout(() => {
      const textX = Math.round(pointX) + offsetX;
      const textY = Math.round(pointY - size - 3) + offsetY;

      // context.font = '14px FontAwesome'; //* works but have to import FA icons
      context.font = `Italic Bold ${labelSize}px Arial`;
      // context.fillStyle = color;
      context.fillStyle = `white`;
      context.textAlign = 'center';
      context.fillText(label, textX, textY);

      //* Works but need font awesome
      // context.fillText('\uF063', textX, textY);
    }, 250);
  }

  if (drawLine) {
    const linePayload = {
      canvas,
      ctx: context, // context
      lineWidth: 3, // lineWidth
      startX: pointX, // startX
      startY: pointY, // startY
      endX: pinX, // endX
      endY: pinY, // endY
      label: `${pinDistance} yds`, // label
      dashed: true, // dashed
    };
    drawCanvasLine(linePayload);

    //* Old ind params - TODO remove
    // drawCanvasLine(context, 3, pointX, pointY, pinX, pinY, `${pinDistance} yds`, true);
  }
  if (drawTeeToBall && teeShot) {
    const teePointX = Math.round(teeX);
    const teePointY = Math.round(teeY);
    const linePayloadB = {
      ctx: context, // context
      lineWidth: 2, // lineWidth
      startX: teePointX, // startX
      startY: teePointY, // startY
      endX: pointX, // endX
      endY: pointY, // endY
      label: null, // label
      dashed: false, // dashed
    };
    drawCanvasLine(linePayloadB);

    //* Old ind params - TODO remove
    // drawCanvasLine(context, 2, teePointX, teePointY, pointX, pointY, null, false);

    //* Used for animating tee shot line
    // drawCanvasLineAnimated(
    //   canvas,
    //   context,
    //   2,
    //   teePointX,
    //   teePointY,
    //   pointX,
    //   pointY,
    //   null,
    //   false,
    //   true,
    //   'blue'
    // );
  }
};

export const drawEdgePoint = (payload) => {
  const {
    canvas,
    // context,
    x = 0,
    y = 0,
    label = '',
    offsetX = 0,
    offsetY = 0,
    labelSize = '14',
    isPoint = true,
    edgeX = 0,
    edgeY = 0,
  } = payload;
  let { context, color = 'white', size } = payload;

  if (!context) {
    context = canvas?.getContext('2d');
  }
  if (color === null || !color || color === '#') {
    color = '#FFF';
  }
  if (size === null || !size) {
    size = 5;
  }

  // * to increase smoothing for numbers with decimal part
  const pointX = Math.round(x);
  const pointY = Math.round(y);
  const edgePointX = Math.round(edgeX);
  const edgePointY = Math.round(edgeY);

  context.beginPath();
  context.fillStyle = color;
  context.globalCompositeOperation = 'destination-over';

  if (isPoint) {
    context.arc(edgePointX, edgePointY, size, 0 * Math.PI, 2 * Math.PI);
  } else {
    context.fillRect(edgePointX, edgePointY, size, size);
  }

  context.fill();

  if (label) {
    setTimeout(() => {
      const textX = Math.round(edgePointX) + offsetX;
      const textY = Math.round(edgePointY - size - 3) + offsetY;

      context.font = `Italic Bold ${labelSize}px Arial`;
      context.fillStyle = `white`;
      context.textAlign = 'center';
      context.fillText(label, textX, textY);
    }, 250);
  }

  const linePayload = {
    ctx: context, // context
    lineWidth: 2, // lineWidth
    startX: edgePointX, // startX
    startY: edgePointY, // startY
    endX: pointX, // endX
    endY: pointY, // endY
    label: null, // label
    dashed: false, // dashed
  };
  drawCanvasLine(linePayload);

  //* Old ind params - TODO remove
  // drawCanvasLine(context, 2, edgePointX, edgePointY, pointX, pointY, null, false);
};

export const drawPointRect = (context, x, y, label, color, size) => {
  if (color === null || !color) {
    color = '#FFF';
  }
  if (size === null || !size) {
    size = 5;
  }

  const radius = 0.5 * size;

  // * to increase smoothing for numbers with decimal part
  const pointX = Math.round(x - radius);
  const pointY = Math.round(y - radius);

  context.globalCompositeOperation = 'destination-over';

  context.beginPath();
  context.fillStyle = color;
  context.fillRect(pointX, pointY, size, size);
  context.fill();

  if (label) {
    setTimeout(() => {
      const textX = Math.round(x);
      const textY = Math.round(pointY - 5);

      // context.font = '14px FontAwesome'; //* works but have to import FA icons
      context.font = 'Italic Bold 16px Arial';
      context.fillStyle = 'white';
      context.textAlign = 'center';
      context.fillText(label, textX, textY);

      //* Works but need font awesome
      // context.fillText('\uF063', textX, textY);
    }, 500);
  }
};
